import { useContext, useEffect } from "react";
import MainContext from "../../../context/mainContext";
import { Box } from "@mui/material";
import styles from "./Search.module.scss";
import { useTranslation } from "react-i18next";
import SearchResult from "./SearchResult";

const Publications: React.FC = () => {
  const { setBanner } = useContext(MainContext);
  const { t } = useTranslation();

  useEffect(() => {
    setBanner("rocky-peak-sunset.png");
  });

  return (
    <Box className={styles.myInboxMain}>
      <div className={styles.myInboxTitle + " " + styles.emptySubtitle}>
        <h2>{t("publication")} <strong>{t("publicationHUB")}</strong></h2>
      </div>
      <SearchResult
        title={t("publications")}
        status="Published"
        sortOrder="publishedDate"
        sortDescending={true}
      />
    </Box>
  );
};

export default Publications;
